export default __webpack_public_path__ + "static/media/bryce-product3.a036e6d6.webp";